const BARS = [38, 60, 42, 75, 52, 68, 48, 88, 58, 72, 82, 92]
const POSITIONS = [
	{ ticker: "AAPL", shares: "100 sh", income: "$432/yr", yld: "2.4%" },
	{ ticker: "MSFT", shares: "50 sh", income: "$180/yr", yld: "0.8%" },
	{ ticker: "JNJ", shares: "75 sh", income: "$348/yr", yld: "3.1%" },
]

export function DashboardMockup() {
	return (
		<div className="rounded-2xl overflow-hidden border border-white/40 dark:border-sky-100/10 bg-white/80 dark:bg-sky-950/80 backdrop-blur-md shadow-2xl">
			{/* Browser chrome */}
			<div className="flex items-center gap-1.5 px-3 py-2.5 bg-sky-50/80 dark:bg-sky-900/40 border-b border-sky-100/60 dark:border-sky-800/30">
				<div className="w-2 h-2 rounded-full bg-red-400/70" />
				<div className="w-2 h-2 rounded-full bg-amber-400/70" />
				<div className="w-2 h-2 rounded-full bg-green-400/70" />
				<div className="ml-2 flex-1 h-4 rounded-full bg-sky-100/80 dark:bg-sky-800/40" />
				<span className="text-[9px] font-bold text-sky-700 dark:text-sky-300">BeeDiv</span>
			</div>

			<div className="p-3 space-y-3">
				{/* Stat cards */}
				<div className="grid grid-cols-3 gap-1.5">
					{[
						{ label: "Net Worth", value: "$125.4K" },
						{ label: "Ann. Income", value: "$4,820" },
						{ label: "Yield", value: "3.85%" },
					].map(({ label, value }) => (
						<div
							key={label}
							className="rounded-xl p-2 bg-sky-50/80 dark:bg-sky-900/40 border border-sky-100/60 dark:border-sky-800/20"
						>
							<div className="text-[9px] text-sky-600/70 dark:text-sky-400/60 leading-tight">{label}</div>
							<div className="text-xs font-bold text-sky-900 dark:text-sky-100 mt-0.5">{value}</div>
						</div>
					))}
				</div>

				{/* Charts row */}
				<div className="flex gap-2">
					{/* Pie chart */}
					<div className="flex-none space-y-1.5">
						<div
							className="w-14 h-14 rounded-full"
							style={{
								background:
									"conic-gradient(#0ea5e9 0% 35%, #38bdf8 35% 58%, #7dd3fc 58% 77%, #bae6fd 77% 100%)",
							}}
						/>
						<div className="space-y-0.5">
							{[
								["AAPL", "#0ea5e9"],
								["MSFT", "#38bdf8"],
								["JNJ", "#7dd3fc"],
							].map(([t, c]) => (
								<div key={t} className="flex items-center gap-1">
									<div className="w-1.5 h-1.5 rounded-full flex-none" style={{ background: c }} />
									<span className="text-[8px] text-sky-700/70 dark:text-sky-300/60">{t}</span>
								</div>
							))}
						</div>
					</div>

					{/* Bar chart */}
					<div className="flex-1">
						<div className="flex items-end gap-px h-14">
							{BARS.map((h, i) => (
								<div
									key={i}
									className="flex-1 rounded-sm"
									style={{
										height: `${h}%`,
										background: i >= 8 ? "#0ea5e9" : "#7dd3fc",
										opacity: 0.85,
									}}
								/>
							))}
						</div>
						<div className="flex justify-between mt-1 px-0.5">
							{["Jan", "Apr", "Jul", "Oct"].map((m) => (
								<span key={m} className="text-[7px] text-sky-500/60 dark:text-sky-400/50">
									{m}
								</span>
							))}
						</div>
					</div>
				</div>

				{/* Positions */}
				<div className="divide-y divide-sky-100/50 dark:divide-sky-800/20">
					{POSITIONS.map((p) => (
						<div key={p.ticker} className="flex items-center justify-between py-1.5">
							<div className="flex items-center gap-1.5">
								<div className="w-5 h-5 rounded-full bg-sky-100 dark:bg-sky-800 flex items-center justify-center flex-none">
									<span className="text-[7px] font-bold text-sky-600 dark:text-sky-300">
										{p.ticker[0]}
									</span>
								</div>
								<div>
									<div className="text-[10px] font-bold text-sky-900 dark:text-sky-100 leading-tight">
										{p.ticker}
									</div>
									<div className="text-[8px] text-sky-500/60 leading-tight">{p.shares}</div>
								</div>
							</div>
							<div className="text-right">
								<div className="text-[10px] font-semibold text-sky-700 dark:text-sky-300 leading-tight">
									{p.income}
								</div>
								<div className="text-[8px] text-sky-500/60 leading-tight">{p.yld}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
